import { Loading } from '@nextui-org/react';

export default Loading;
